const $ = jQuery;

export function updateCredits(credits) {
    $('.growtype-chat-credits .growtype-chat-credits-amount').html(credits);
}
